import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { AppConfig } from "../config/config";
import { ResponsePackage } from "shared-lib";
import { ProjectDesignation, ProjectDesignationDto } from "../models/projectDesignation.model";
import { ProjectDesignationForConfirmPaymentDto } from "../models/projectDesignationForConfirmPayment.model";
import { Observable } from "rxjs";

@Injectable({
  providedIn: 'root',
})

export class ProjectDesignationService {
  private pathApi = this.config.setting['pathApi'] + 'projectDesignation/';
  private headers = new HttpHeaders({ 'Content-Type': 'application/json' });

  constructor(private http: HttpClient, private config: AppConfig) {}

  public getAllForSelect(utilityId: number | null = null) {
        if(utilityId) {
          return this.http.get<ResponsePackage<ProjectDesignationDto[]>>(`${this.pathApi}getAllForSelect/${utilityId}`,{headers: this.headers, observe: 'response'});
        }
        else {
          return this.http.get<ResponsePackage<ProjectDesignationDto[]>>(`${this.pathApi}getAllForSelect`,{headers: this.headers, observe: 'response'});
        }
      }

  public getAllForConfirmPayment(utilityId: number | null = null) {
        if(utilityId) {
          return this.http.get<ResponsePackage<ProjectDesignationForConfirmPaymentDto[]>>(`${this.pathApi}getAllForConfirmPayment/${utilityId}`,{headers: this.headers, observe: 'response'});
        }
        else {
          return this.http.get<ResponsePackage<ProjectDesignationForConfirmPaymentDto[]>>(`${this.pathApi}getAllForConfirmPayment`,{headers: this.headers, observe: 'response'});
        }
      }

  public getAll(dataIn: any): Observable<any> {
    return this.http.post<ResponsePackage<ProjectDesignation>>(`${this.pathApi}getAll`, dataIn);
  }

  public save(dataIn: any): Observable<any> {
    return this.http.post<any>(`${this.pathApi}save`,dataIn);
  }

  public delete(id: number): Observable<any> {
    return this.http.delete(`${this.pathApi}delete/${id}`);
  }
}
